<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
    }
  }
}
</script>

<style lang="scss"></style>
